import api from '../lib/axios';

export const getMe = () => api.get('/auth/me');
export const getDashboard = () => api.get('/auth/dashboard');
export const logout = () => api.get('/auth/logout');
export const login = (data) => api.post('/auth/login', data);
export const register = (data) => api.post('/auth/register', data);
export const forgotPassword = (data) => api.post('/auth/forgot-password', data);
export const resetPassword = (token, data) => api.post(`/auth/reset-password/${token}`, data);
export const updateMe = (data) => api.patch('/auth/update-me', data);
export const updatePassword = (data) => api.patch('/auth/update-password', data);
